import CarSwap from '@carvana/ds-icons/TradeinSpot';
import Skeleton from '@carvana/ds-skeleton';
import { icon } from '@carvana/ds-styles';
import FinanceCard from './Prequalified/CustomizeYourDeal/FinanceCard';

export function GenericSkeleton() {
  return (
    <>
      {/* hero */}
      <div className="relative">
        <Skeleton
          className="rounded-none h-[490px]! sm:h-[300px]! md:h-[260px]! relative mb-[100px] sm:mb-[125px] md:mb-[250px]"
          width="100%"
        />
        <Skeleton className="absolute top-40 left-1/2 sm:top-1/2 -translate-x-1/2 h-[520px]! sm:h-[300px]! md:h-[360px] max-w-[1272px] md:m-auto w-[90%]! lg:w-[80%]!" />
      </div>

      <div className="px-2xl py-6xl max-w-[1272px] m-auto flex flex-col gap-9xl">
        {/* cards */}
        <div className="flex flex-col gap-2xl">
          <Skeleton height="80px" width="100%" />
          <div className="flex h-[600px] sm:h-[200px]! md:h-[250px] w-full flex-col gap-xl sm:flex-row sm:gap-2xl">
            <Skeleton height="100%" width="100%" />
            <Skeleton height="100%" width="100%" />
            <Skeleton height="100%" width="100%" />
          </div>
        </div>

        <div className="h-[900px] md:h-[750px] lg:h-[600px]">
          <Skeleton height="100%" width="100%" />
        </div>

        {/* reviews */}
        <div className="h-[400px]">
          <Skeleton height="100%" width="100%" />
        </div>

        {/* ready to apply */}
        <div className="h-[600px]">
          <Skeleton height="100%" width="100%" />
        </div>

        {/* here to help */}
        <div className="h-[600px]">
          <Skeleton height="100%" width="100%" />
        </div>
      </div>
    </>
  );
}

export function InventoryLineSkeleton() {
  return (
    <Skeleton className="rounded-sm w-full! sm:w-[300px]!" height="48px" />
  );
}

export function CardSkeleton() {
  return <Skeleton className="rounded-md" height="283px" width="100%" />;
}

export function TradeInSkeleton() {
  return (
    <FinanceCard
      heading="Trade-in"
      icon={<CarSwap color={icon.primary} size={24} />}
      text={<Skeleton height="20px" width="90%" />}
    >
      <Skeleton height="60px" width="100%" />
    </FinanceCard>
  );
}
